import React from "react";
import PropTypes from "prop-types";
import { Popover, PopoverBody } from "reactstrap";

const ToolTip = ({ target, content, popoverOpen, toggle }) => {
  return (
    <div>
      <Popover
        trigger="legacy"
        placement="bottom"
        toggle={toggle}
        isOpen={popoverOpen}
        target={target}
      >
        <PopoverBody>{content}</PopoverBody>
      </Popover>
    </div>
  );
};

ToolTip.propTypes = {
  target: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  popoverOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default ToolTip;
